import React from 'react';
import styles from './ReportSectionSelectOptionItem.module.scss';
import { ReportableChip } from '../../../../ReportChips/ReportableChip/ReportableChip';
import {
  StatusChip,
  StatusChipProps
} from '../../../../ReportChips/StatusChip/StatusChip';

export interface ReportSectionSelectOptionItemProps {
  title: string;
  subTitle: string;
  statusChips?: StatusChipProps;
}

export const ReportSectionSelectOptionItem = ({
  title,
  subTitle,
  statusChips
}: ReportSectionSelectOptionItemProps): React.ReactElement<ReportSectionSelectOptionItemProps> => {
  return (
    <div>
      <div className={styles.reportSectionSelectOptionItem}>
        <div className={styles.content}>
          <p className={styles.title}>{title}</p>
          <p className={styles.subTitle}>{subTitle}</p>
          {statusChips && (
            <div className={styles.statusChips}>
              <ReportableChip
                isReportable={statusChips.isReportable}
                size="tiny"
              />
              <StatusChip
                isReportable={statusChips.isReportable}
                status={statusChips.status}
                size="tiny"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
